import { environment } from './../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './../../../../shared/Services/BaseService';
import { Injectable } from '@angular/core';
import { authenticationService } from '../../../../shared/Services/authenticationService';

@Injectable({
  providedIn: 'root',
})
export class WorkFlowService extends BaseService {

constructor(http: HttpClient, auth: authenticationService) {
  super(http, auth, environment.apiUrl + 'workflow');
 }
}
